export const voteTargetDate = new Date('2026-06-16T23:59:59+02:00');

export interface VoteStateType {
  votingEnded: boolean;
}

export const VoteState: VoteStateType = $state({
  votingEnded: Date.now() >= voteTargetDate.getTime(),
});

if (!VoteState.votingEnded) {
  const interval = setInterval(() => {
    if (Date.now() >= voteTargetDate.getTime()) {
      VoteState.votingEnded = true;
      clearInterval(interval);
    }
  }, 1000);
}
